import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

class SigningForm
{
    static async getPreIncorporationData()
    {
        const response = await axios.get('api/admin/formation/pre-incorporation-form-data');

        return response.data.data;
    }

    static async getIncorporationData()
    {
        const response = await axios.get('api/admin/formation/incorporation-form-data');

        return response.data.data;
    }

    static async generatePreIncorporationDocuments(data)
    {
        await axios.post('api/admin/formation/generate-pre-incorporation-documents', data);
    }

    static async generateIncorporationDocuments(data)
    {
        await axios.post('api/admin/formation/generate-incorporation-documents', transformObjectValuesToUpperCase(data));
    }

    // transfer company
    static async getTransferCompanyFormData()
    {
        const response = await axios.get('api/admin/formation/transfer-company-form-data');
        
        return response.data.data;
    }

    static async generateTransferCompanyDocuments(data)
    {
        await axios.post('api/admin/formation/generate-transfer-company-documents', data);
    }
    
}
export default SigningForm;